/* eslint-disable css-modules/no-unused-class  */
import { FC } from 'react';
import { Divider, Icon } from 'learning-panel-components';
import moment from 'moment';
import { translate } from 'translations';
import styles from './resultsCard.module.scss';

const ResultsCard: FC<ResultsCardProps> = (props: ResultsCardProps) => {
    const { name, score, totalQuestions, correctAnswers, startDate, endDate, answers, isEmpty } = props;

    const getDetail = (title: string, value: string) => {
        return (
            <div className={styles.detail}>
                <div className={styles.title}>{title}</div>
                <div className={styles.value}>{value}</div>
            </div>
        );
    };
    return (
        <div className={styles['results-wrapper']}>
            <div className={styles.top}>
                {!isEmpty ? (
                    <div className={styles['title-wrapper']}>
                        <Icon name="assessmentIconLearningPanel" />
                        <div className={styles.title}>{name}</div>
                    </div>
                ) : (
                    <div className={styles['title-wrapper-empty']}></div>
                )}
                <div className={styles.details}>
                    {!isEmpty ? getDetail(translate('UserRating'), `${score}%`) : getDetail(translate('Score'), '%')}
                    <div className={styles.line} />
                    {getDetail(translate('AnswersRate'), !isEmpty ? `${correctAnswers}/${totalQuestions}` : '-')}
                    <div className={styles.line} />
                    {getDetail(
                        translate('TimePeriod'),
                        !isEmpty
                            ? `${moment(startDate).format('MMM DD ,YYYY')} - ${moment(endDate).format('MMM DD ,YYYY')}`
                            : '--/--/----'
                    )}
                </div>
            </div>
            <Divider orientation="horizontal" className={styles.divider} color="rgba(255, 255, 255, 0.2)" />
            {!isEmpty ? (
                <div className={styles.answers}>
                    <table>
                        <thead>
                            <tr>
                                <th>{translate('QuestionNo.')}</th>
                                <th>{translate('Category')}</th>
                                <th>{translate('Vulnerability')}</th>
                                <th>{translate('Result')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {answers.map((answer, i) => (
                                <tr key={i}>
                                    <td className={styles['centered-column']}>
                                        <div className={styles['question-number']}>{i + 1}</div>
                                    </td>
                                    <td className={styles['answer-text']}>{answer.category}</td>
                                    <td className={styles['answer-text']}>{answer.vulnerability}</td>
                                    <td className={styles['centered-column']}>
                                        {<Icon name={answer.isCorrect ? 'correct' : 'incorrect'} />}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className={styles['empty-state']}>
                    <div className={styles.text}>{translate('AssessmentResultsWillShowHere')}</div>
                    <img
                        src={`${process.env.PUBLIC_URL}/images/assessmentResultEmptyState.svg`}
                        className={styles.image}
                        alt="resultCard"
                    ></img>
                </div>
            )}
        </div>
    );
};

export interface ResultsCardProps {
    name: string;
    score: number;
    totalQuestions: number;
    correctAnswers: number;
    startDate: Date;
    endDate: Date;
    answers: ResultsCardAnswer[];
    isEmpty?: boolean;
}

interface ResultsCardAnswer {
    category: string;
    vulnerability: string;
    isCorrect: boolean;
}
export default ResultsCard;
